var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"images-block"},_vm._l((_vm.imagesList),function(item,index){return _c('img',{key:index,attrs:{"src":item,"width":"300","height":"300"}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }